import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InsertChartOutlinedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"insert_chart_outlined"}/>
}
